import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-monthly-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './monthly-selector.component.html',
  styleUrls: ['./monthly-selector.component.scss']
})
export class MonthlySelectorComponent {
  @Input() selectedMonth: string = 'június';
  @Input() selectedYear: number = 2025;
  @Input() daysInMonth: number = 30;
  @Input() isKumMode: boolean = false;
  @Input() isCallCenterEmployee: boolean = false; // ✅ Új input Call Center muntatárs detektáláshoz
  @Input() isKumEmployee: boolean = false; // ✅ Új input KÜM munkatárs detektáláshoz
  @Input() isBothCcAndKum: boolean = false; // ✅ Kettős szerepkör: CC + KÜM
  @Input() showYearlyOption: boolean = true; // Éves összesítő opció megjelenítése
  @Input() showExport: boolean = true;
  @Input() exportDisabled: boolean = false;
  @Input() isExporting: boolean = false;

  @Output() monthChange = new EventEmitter<string>();
  @Output() yearChange = new EventEmitter<number>();
  @Output() modeChange = new EventEmitter<boolean>();
  @Output() addNewMetric = new EventEmitter<void>();
  @Output() exportRequested = new EventEmitter<void>();

  months = [
    'január', 'február', 'március', 'április', 'május', 'június',
    'július', 'augusztus', 'szeptember', 'október', 'november', 'december',
    'összes'
  ];

  get visibleMonths(): string[] {
    return this.showYearlyOption ? this.months : this.months.filter(m => m !== 'összes');
  }

  get isYearlyView(): boolean {
    return this.selectedMonth === 'összes';
  }

  onMonthChange() {
    this.monthChange.emit(this.selectedMonth);
  }

  onYearChange() {
    this.yearChange.emit(this.selectedYear);
  }

  onModeChange() {
    this.modeChange.emit(this.isKumMode);
  }

  onExportClick() {
    this.exportRequested.emit();
  }
}